import { Box, Grid, Typography, useTheme } from '@mui/material';
import { FC, useCallback, useEffect, useState } from 'react';
// components
import { DashboardStatsChartImg } from 'assets/svgs';
import DashboardStatsCard from '../DashboardStatsCard';
import RecentFormulaTable from './RecentFormulaTable';
// styles, interfaces
import {
  DASHBOARD_TEXT,
  HTTP_STATUS,
  MY_FORMULAS_TEXT,
  ORG_FORMULAS_TEXT,
  ORG_INGREDIENTS_TEXT,
  orgInitialValues,
} from 'constants/index';
import { OrgDashboardPayload, useGetStaffDashboardLazyQuery } from 'generated/graphql';
import { flexCenterBetween } from 'styles/commonComponentStyle';

const StaffDashboard: FC = () => {
  const { palette } = useTheme();

  const [data, setData] = useState<OrgDashboardPayload>(orgInitialValues);

  const [getStaffDashboard, { loading }] = useGetStaffDashboardLazyQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,

    onCompleted: (res) => {
      const { getOrgDashboard } = res || {};
      const { response } = getOrgDashboard || {};
      const { status } = response || {};

      if (status === HTTP_STATUS.SUCCESS) {
        setData(getOrgDashboard);
      } else {
        setData(orgInitialValues);
      }
    },
    onError: () => {
      setData(orgInitialValues);
    },
  });

  const fetchDashboard = useCallback(async () => {
    try {
      await getStaffDashboard();
    } catch (error) {
      console.log('error', error);
    }
  }, [getStaffDashboard]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  const { ingredients, formulas, myFormulas } = data || {};

  return (
    <>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{DASHBOARD_TEXT}</Typography>
      </Box>

      <Grid container spacing={3} mt={1}>
        <Grid item xl={4} lg={6} md={6} sm={12} xs={12}>
          <DashboardStatsCard
            loading={loading}
            icon={<DashboardStatsChartImg color={palette.bluePaletteColor.main} />}
            stats={`${ingredients ?? 0}`}
            title={ORG_INGREDIENTS_TEXT}
          />
        </Grid>

        <Grid item xl={4} lg={6} md={6} sm={12} xs={12}>
          <DashboardStatsCard
            loading={loading}
            icon={<DashboardStatsChartImg color={palette.customRedColor.main} />}
            stats={`${formulas ?? 0}`}
            title={ORG_FORMULAS_TEXT}
          />
        </Grid>

        <Grid item xl={4} lg={6} md={6} sm={12} xs={12}>
          <DashboardStatsCard
            loading={loading}
            icon={<DashboardStatsChartImg color={palette.primary.main} />}
            stats={`${myFormulas ?? 0}`}
            title={MY_FORMULAS_TEXT}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} mt={1}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <RecentFormulaTable />
        </Grid>
      </Grid>
    </>
  );
};

export default StaffDashboard;
